import {userAuthRequest} from '@/http/request.js'
import {pushLogin} from '@/router/util.js'
import {useRootStore} from '@/store/index.js'
import {isStringBoolean} from '@/util/common.js'
import {showWarnMessage} from '@/util/message.js'

export async function appBeforeEnter(to, from, next) {
  console.debug('appBeforeEnter: %s -> %s', from.fullPath, to.fullPath)
  console.debug('appBeforeEnter: %o -> %o', from, to)

  const store = useRootStore()

  try {
    if (!store.userInfo.userId) {
      store.setUserInfo(await userAuthRequest())
    }
  } catch (e) {
    store.setUserInfo({})
  }

  if (to.meta.menuId) {
    store.subMenuId = to.meta.menuId
  }

  if (to.meta.isNotAuth) {
    if (store.userInfo.userId) {
      next('/')
      return
    }
  }

  if (to.meta.isAuth) {
    if (!store.userInfo.userId) {
      pushLogin(() => next('/login'))
      return
    }

    if (to.meta.isNotMember && isStringBoolean(store.userInfo.isMember)) {
      showWarnMessage('当前页面会员无法访问，跳转到会员信息页面')
      next('/memberInfoView')
      return
    }

    if (to.meta.isMember && !isStringBoolean(store.userInfo.isMember)) {
      showWarnMessage('当前页面只有会员才能访问，跳转到会员注册页面')
      next('/noticeView')
      return
    }
  }

  next()
}

export function routerBeforeEach(to, from, next) {
  console.debug('beforeEach: %s -> %s', from.fullPath, to.fullPath)
  console.debug('beforeEach: %o -> %o', from, to)
  next()
}
